import { required } from 'vuelidate/lib/validators'

export const validateData = {
  form: {
    ramais: { required },
    url: { required },
    token: { required },
    audioHorario: { required },
    audioSenha: { required },
    timeout: { required },
  },
}

export const validateComputed = {
  ramaisErrors() {
    const errors = []
    if (!this.$v.form.ramais.$dirty) return errors
    !this.$v.form.ramais.required && errors.push('Ramal é obrigatório.')
    return errors
  },
  urlErrors() {
    const errors = []
    if (!this.$v.form.url.$dirty) return errors
    !this.$v.form.url.required && errors.push('url é obrigatório.')
    return errors
  },
  tokenErrors() {
    const errors = []
    if (!this.$v.form.token.$dirty) return errors
    !this.$v.form.token.required && errors.push('token é obrigatório.')
    return errors
  },
  audioHorarioErrors() {
    const errors = []
    if (!this.$v.form.audioHorario.$dirty) return errors
    !this.$v.form.audioHorario.required && errors.push('Áudio de horário é obrigatório.')
    return errors
  },
  audioSenhaErrors() {
    const errors = []
    if (!this.$v.form.audioSenha.$dirty) return errors
    !this.$v.form.audioSenha.required && errors.push('Áudio senha é obrigatório.')
    return errors
  },
  timeoutErrors() {
    const errors = []
    if (!this.$v.form.timeout.$dirty) return errors
    !this.$v.form.timeout.required && errors.push('Timeout é obrigatório.')
    return errors
  },
}


export const validateDataIa = {
  form: {
    path:{required}
  },
}


export const validateComputedIa = {
  pathErrors() {
    const errors = []
    if (!this.$v.form.path.$dirty) return errors
    !this.$v.form.path.required && errors.push('Caminho é obrigatório.')
    return errors
  },
}


